<template>
    <v-col
        :key="element.type"
        :cols="small ? cols : 2"
        :class="elementClass">
        <v-card
            flat
            :key="element.type"
            :id="'element-card-' + element.type"
            class="campaign-card">

            <div class="element-data"
                 :data-type="element.type"
            />

            <div class="image-container rounded grey-border elevation-4 element-tile-container-height"
                 @mouseover="hover = true"
                 @mouseleave="hover = false"
            >
                <eicon :kind="element.eicon" :style="{fontSize: '80px'}" class="eicon-center"/>

                <div class="d-flex h-100 align-end image-title-text py-1 px-2 text-truncate justify-center">
                    {{ element.name }}
                </div>
            </div>
        </v-card>
    </v-col>
</template>

<script>
    import GenericElementTile from "./genericElementTile.vue";

    export default {
        components: {GenericElementTile},
        props: [
            'element',
            'small',
            'elementClass',
        ],
        data: function () {
            return {
                hover: false,
            }
        },
        computed: {
            cols: function () {
                if (this.elementClass === 'two-in-a-row') {
                    return 6;
                } else if (this.elementClass === 'three-in-a-row') {
                    return 4;
                } else if (this.elementClass === 'four-in-a-row') {
                    return 3;
                } else if (this.elementClass === 'five-in-a-row') {
                    return 2;
                }
            }
        },
    }
</script>

<style>
    .element-tile-container-height {
        height: calc(var(--thumbnail-hover-zoom-height) + 29px);
    }
</style>
